import { GetBookedAppointments } from "../APIs/api-routes.util";
import React from "react";
import { ListGroup } from "react-bootstrap";

function GetPoneBookings(props: any) {
  const { phone, handelUpdate, setShowLoader } = props;
  const [phoneData, setPhoneData] = React.useState([]);

  React.useMemo(() => {
    const checkPhone = () => {
      setShowLoader(true);
      GetBookedAppointments(phone).subscribe((res: any) => {
        setPhoneData(res.response?.data);
        setShowLoader(false);
      });
    };
    checkPhone();
  }, [phone,setShowLoader]);
  return (
    <div className="flex">
      {phoneData.length > 0 ? (
        phoneData?.map((item: any) => {
          return (
            <>
              <ListGroup
                onClick={() => {
                  handelUpdate({
                    name: item.Name,
                    guardianName: item.GuardianName,
                  });
                  props.setShowModel(false);
                }}
                style={{ width: "350px", cursor: "pointer" }}
              >
                <ListGroup.Item>{item.Date}</ListGroup.Item>
                <ListGroup.Item>{item.Name}</ListGroup.Item>
                <ListGroup.Item>{item.Phone}</ListGroup.Item>
                <ListGroup.Item>{item.GuardianName}</ListGroup.Item>
              </ListGroup>
              <br />
            </>
          );
        })
      ) : (
        <text>There is no record found</text>
      )}
    </div>
  );
}

export default GetPoneBookings;
